export class CategoryWithoutWordsAndSimpleReference {
  constructor(
    public id: number,
    public name: string,
    public parentId: number,
    public parentName: string,
    public isRoot: boolean,
    public isWordField: boolean,
    public isDach: boolean
  ) {
  }
}
